import { useState } from 'react';

export default function MoodForm() {
    const [mood, setMood] = useState('');
    const [energy, setEnergy] = useState('');
    const [directionality, setDirectionality] = useState('');
    const [activity, setActivity] = useState('');
    const [emotion, setEmotion] = useState('');
    const [timestamp, setTimestamp] = useState('');

    function handleMoodChange(e) {
        setMood(e.target.value);
    }

    function handleEnergyChange(e) {
        setEnergy(e.target.value);
    }

    function handleDirectionalityChange(e) {
        setDirectionality(e.target.value);
    }

    function handleActivityChange(e) {
        setActivity(e.target.value);
    }

    function handleEmotionChange(e) {
        setEmotion(e.target.value);
    }

    function handleTimestampChange(e) {
        setTimestamp(e.target.value);
    }

    async function handleSubmit() {
        const formTimestamp = timestamp ? new Date(parseInt(timestamp)).getTime() : Date.now();
        const req = {
            method: 'POST',
            body: JSON.stringify({
                mood,
                energy,
                directionality,
                activity,
                emotion,
                timestamp: formTimestamp,
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
        };
        await fetch('https://life.pmusgrave.dev/mood', req)
            .catch((err) => {
                console.log(err.message);
            });
        setMood('');
        setEnergy('');
        setDirectionality('');
        setActivity('');
        setEmotion('');
        setTimestamp('');
    }

    return (
        <div className="form-container">
            <h2>Mood Form</h2>
            <form onSubmit={e => e.preventDefault()}>
                <div className="form-group">
                    <label htmlFor="mood">Mood (0-100):</label>
                    <input
                        id="mood"
                        type="number"
                        min="0"
                        max="100"
                        value={mood}
                        onChange={handleMoodChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="energy">Energy (0-100):</label>
                    <input
                        id="energy"
                        type="number"
                        min="0"
                        max="100"
                        value={energy}
                        onChange={handleEnergyChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="directionality">Directionality (-100 to 100):</label>
                    <input
                        id="directionality"
                        type="number"
                        min="-100"
                        max="100"
                        value={directionality}
                        onChange={handleDirectionalityChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="activity">Current Activity (optional):</label>
                    <input
                        id="activity"
                        type="text"
                        value={activity}
                        onChange={handleActivityChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="emotion">How are you feeling? (optional):</label>
                    <input
                        id="emotion"
                        type="text"
                        value={emotion}
                        onChange={handleEmotionChange}
                        placeholder="e.g., happy, anxious, excited"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="timestamp">Timestamp (optional):</label>
                    <input
                        id="timestamp"
                        type="number"
                        value={timestamp}
                        onChange={handleTimestampChange}
                        placeholder="Unix timestamp"
                    />
                </div>
                <button 
                    onClick={handleSubmit}
                    className="submit-button"
                >
                    Submit
                </button>
            </form>
        </div>
    );
} 
